module.exports = __webpack_public_path__ + "static/media/19ESCAP3.43ed3623.jpg";